<template>
	<div id="app" :class="['zutool-wrapper', viewMode]">
		<router-view />
	</div>
</template>

<script>
// Vuex
import { mapActions, mapGetters } from 'vuex'
import { SET_IS_ANDROID } from './store/modules/common/mutation-types'

export default {
	name: 'App',
	components: {
	},
	data () {
		return {
		}
	},
	computed: {
		...mapGetters('common', ['viewMode', 'isAndroid'])
	},
	created () {
		// NOTE: 横画面時のアラート処理
		// CHANGED: Webviewでしか使用しないのでコメントアウト
		// const ons = this.$ons
		// ons.orientation.on('change', (e) => {
		// 	if (!e.isPortrait) {
		// 		ons.notification.alert({ message: '画面を縦にしてご利用ください。', title: '' })
		// 	}
		// })

		// Android判定しstoreに格納
		// NOTE: User-Agent Client Hints対応
		const userAgentCh = window.navigator.userAgentData
		// console.log('userAgentCh: ', userAgentCh)	// Debug用
		// User-Agent Client Hintsが利用できるようであれば
		if (userAgentCh) {
			this.SET_IS_ANDROID(userAgentCh.platform.toLowerCase() === 'android')
		} else {
			const userAgent = window.navigator.userAgent.toLowerCase()
			this.SET_IS_ANDROID(userAgent.indexOf('android') >= 0)
		}

		// header内に追加するアドマネージャーのscriptの出しわけ
		let adsScript = document.createElement('script')
		adsScript.async = true
		adsScript.src = 'https://securepubads.g.doubleclick.net/tag/js/gpt.js'
		document.head.appendChild(adsScript)
		if (this.isAndroid) {
			// Android
			let adsScript1 = document.createElement('script')
			adsScript1.text = `window.googletag = window.googletag || {cmd: []};googletag.cmd.push(function() {googletag.defineSlot('/83555300,21874363093/BellSystem24/BellSystem24_Android/JP_zutool_Android_rectangle_weatherforecast2', [320, 100], 'div-gpt-ad-1666592155251-0').addService(googletag.pubads());googletag.pubads().enableSingleRequest();googletag.enableServices();});`
			let adsScript2 = document.createElement('script')
			adsScript2.text = `window.googletag = window.googletag || {cmd: []};googletag.cmd.push(function() {googletag.defineSlot('/83555300,21874363093/BellSystem24/BellSystem24_Android/JP_zutool_Android_rectangle_weatherforecast1', [300, 250], 'div-gpt-ad-1666592024900-0').addService(googletag.pubads());googletag.pubads().enableSingleRequest();googletag.enableServices();});`
			document.head.appendChild(adsScript1)
			document.head.appendChild(adsScript2)
		} else {
			// iOS
			let adsScript1 = document.createElement('script')
			adsScript1.text = `window.googletag = window.googletag || {cmd: []}; googletag.cmd.push(function() { googletag.defineSlot('/83555300,21874363093/BellSystem24/BellSystem24_iOS/JP_zutool_iOS_rectangle_weatherforecast2', [320, 100], 'div-gpt-ad-1661170141676-0').addService(googletag.pubads()); googletag.pubads().enableSingleRequest(); googletag.enableServices(); });`
			let adsSript2 = document.createElement('script')
			adsSript2.text = `window.googletag = window.googletag || {cmd: []}; googletag.cmd.push(function() { googletag.defineSlot('/83555300,21874363093/BellSystem24/BellSystem24_iOS/JP_zutool_iOS_adaptivebanner_weatherforecast1', [300, 250], 'div-gpt-ad-1661169962020-0').addService(googletag.pubads()); googletag.pubads().enableSingleRequest(); googletag.enableServices(); });`
			document.head.appendChild(adsScript1)
			document.head.appendChild(adsSript2)
		}
	},
	mounted () {
	},
	methods: {
		// map Vuex actions
		...mapActions('common', [SET_IS_ANDROID])
	}
}
</script>

<style lang="scss">
@import '~onsenui/css/onsenui.css';
// TODO: テーマローラーで作成したものに差し替える
@import '~onsenui/css/onsen-css-components.css';
// @import "assets/sass/overview";

// 変数定義SASS
@import "assets/sass/variable";

// 共通SASS
@import "assets/sass/common";
</style>
